module.exports = __webpack_public_path__ + "img/andrew-pro.fc605686.jpg";